class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element && section.section) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    // Update cart icon count in header
    const cartCountElements = document.querySelectorAll('.elementor-button-icon-qty');
    let totalCount = 0;
    if (cartCountElements.length > 0) {
      if (parsedState.sections && parsedState.sections['cart-icon-bubble']) {
        // Parse cart count from cart-icon-bubble section HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections['cart-icon-bubble'], 'text/html');
        const countSpan = doc.querySelector('span[aria-hidden="true"]');
        if (countSpan) {
          const val = parseInt(countSpan.textContent.trim(), 10);
          if (!isNaN(val)) totalCount = val;
        }
      }
      cartCountElements.forEach((el) => {
        el.textContent = totalCount;
        el.setAttribute('data-counter', totalCount);
      });
    }

    // Dispatch custom event for cart update
    const cartUpdateEvent = new CustomEvent('cart:updated', {
      detail: {
        itemCount: totalCount,
        cart: parsedState.cart || null,
      },
    });
    document.dispatchEvent(cartUpdateEvent);

    // Show feedback to user with toast notification
    let productInfo = '';
    let productName = '';
    let quantity = '';

    // Try to find the newly added product in parsedState.cart.items using this.cartItemKey
    if (parsedState.cart && Array.isArray(parsedState.cart.items) && this.cartItemKey) {
      const addedItem = parsedState.cart.items.find(item => item.key === this.cartItemKey);
      if (addedItem) {
        productName = addedItem.product_title || addedItem.title || '';
        quantity = addedItem.quantity ? String(addedItem.quantity) : '';
      }
    }

    // Fallback to parsing HTML section if productName is still empty
    if (!productName && parsedState.sections && parsedState.sections['cart-notification-product']) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(parsedState.sections['cart-notification-product'], 'text/html');
      // Improved selector to include more possible product title classes and data attributes
      const productNameEl = doc.querySelector('.cart-notification-product__title, .product-title, h3, h2, [data-product-title], [data-product-name]');
      const quantityEl = doc.querySelector('.cart-notification-product__quantity, .quantity, .product-quantity');
      if (quantityEl) {
        quantity = quantityEl.textContent.trim();
      } else {
        const textContent = doc.body.textContent || '';
        const qtyMatch = textContent.match(/Quantity:\s*(\d+)/i);
        if (qtyMatch) {
          quantity = qtyMatch[1];
        }
      }
      productName = productNameEl ? productNameEl.textContent.trim() : '';
    }

    productInfo = productName + (quantity ? ` (Quantity: ${quantity})` : '');
    const toastMessage = productInfo ? `"${productInfo}" added to cart` : `An item has been added to the cart.`;
    showToast(toastMessage);

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        section: 'cart-notification-product',
        selector: '#cart-notification-product',
      },
      {
        id: 'cart-notification-button',
        section: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const element = doc.querySelector(selector);
    if (element) {
      return element.innerHTML;
    }
    return '';
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
